import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loader = ({ loading }) => (
    <>
        {loading && (
            <div className="spinner-container">
                <Spinner size="xl" animation="border" variant="dark" />
            </div>
        )}
    </>
);

export default Loader;
